import React, { Component } from 'react';
import { connect } from 'react-redux';
import { volumeChange, powerToggle, bankToggle } from '../../actions/SettingsAction';

import './ControlPad.css';

class ControlPad extends Component{

	constructor(props){
		super(props);

		this.state = {
			volume: 70
		};
	
		this.onPowerToggle = this.onPowerToggle.bind(this);
		this.onBankToggle = this.onBankToggle.bind(this);
		this.onVolumeSlide = this.onVolumeSlide.bind(this);
	}

	onPowerToggle(e){
		this.props.powerToggle();
	}

	onBankToggle(e){
		this.props.bankToggle();
	}

	onVolumeSlide(e){
		this.props.volumeChange(e.target.value/100);
		this.setState({
			volume: e.target.value	
		});		
	}

	render(){
		
		return (
			<div className="ControlPad">
				<div className="toggleControl">
					<h3>Power</h3>
					<input 
						type="checkbox" 
						id="power-switch"
						value= {this.state.powerOn}
						onChange={this.onPowerToggle} />
					<label htmlFor="power-switch">Toggle</label>
				</div>
				<div className="information-screen">
					{this.props.btext}	
				</div>
				<div >
				 <input 
				 	id="volume" 
					className="volume-control" 
					max="100" 
					min="0" 
					type="range" 
					value= {this.state.volume}
					onChange={this.onVolumeSlide}	
					/>
				</div>
				<div className="toggleControl">
					<h3>Bank</h3>
					<input 
						type="checkbox" 
						id="bank-switch"
						value={this.state.bankOn}
						onChange={this.onBankToggle}/>
					<label htmlFor="bank-switch">Toggle</label>
				</div>

			</div>
		);
	}
}

const mapStateToProps = state => ({
	btext: state.settings.btext	
});

export default connect(mapStateToProps, {volumeChange, powerToggle, bankToggle})(ControlPad);
